import _ from 'underscore';
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

const PromotionBannerContext = React.createContext({
  isHidePromotionBanner: true,
  setIsHidePromotionBanner: _.noop,
  bannerInfo: null,
  setBannerInfo: _.noop,
});

export const PromotionBannerContextProvider = (props) => {
  const { children } = props;
  // Context used to forcibly hide/unhide promotion banner even when coupon is
  // available. Eg. used by payment step and other steps that need to suppress promo banner.
  const [isHidePromotionBanner, setIsHidePromotionBanner] = useState(true);
  const [bannerInfo, setBannerInfo] = useState(null);

  return (
    <PromotionBannerContext.Provider
      value={{
        isHidePromotionBanner,
        setIsHidePromotionBanner,
        bannerInfo,
        setBannerInfo,
      }}
    >
      {children}
    </PromotionBannerContext.Provider>
  );
};

PromotionBannerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePromotionBannerContext = () => useContext(PromotionBannerContext);
